export default __webpack_public_path__ + "static/media/vitalik_poap_13.2dcfe200.svg";